module.exports = __webpack_public_path__ + "static/img/1.ae23552.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/裤子/1.png
// module id = uv0Q
// module chunks = 0